import React from 'react';
import SelectFancy from '@atoms/SelectFancy';
import usePersonalResponsibilityOptions from '@hooks/usePersonalResponsibilitiesOptions';

const SelectPersonalResponsibilities = ({ label="Personal Responsibility", isDisabled=false, ...props }) => {
    const { isLoading, data, error } = usePersonalResponsibilityOptions();

    if (error) {
        return null;
    }

    return (
        <SelectFancy
            isDisabled={isDisabled}
            label={label}
            name="personalResponsibility"
            options={data}
            isLoading={isLoading}
            {...props}
        />
    );
};

export default SelectPersonalResponsibilities;
